export default {

  //存储数据
  state: {
		menuName:'首页',
		userName:'用户名',
		defaultNewVal:"账户总览",
  },
  //调用方法
  mutations: {
		//设置面包屑
		setMenuName(state,newVal){
			state.menuName = newVal;
			if(newVal == 'null' || newVal == undefined){
				newVal = state.defaultNewVal;
			}
			localStorage.setItem('menuName',newVal);
		},
		//设置用户名
		setUserName(state,newVal){
			state.userName = newVal
		}
  },
  actions: {}
}
